import React from 'react';

import {SparklesIcon} from '@heroicons/react/outline';
import Button, {ButtonSizes} from '../../components/ButtonNew';
import Stars from '../../components/Stars';
import YouTubeVideo from '../../components/YouTubeVideo';
import {LANDING_VIDEO} from '../../constants/coaching';
import {cx} from '../../util';


const CoachLandingHero = ({
  pageTitle, pageSubtitle, onClickCTA, showTestimonial, compactTitle,
}) => (
  <div className="max-w-7xl mx-auto pt-4 pb-4 justify-center text-center flex md:pt-8 md:pb-8 md:flex-col">
    <div className="items-center md:flex md:gap-12">
      <div className="justify-center text-center md:w-2/3 lg:w-3/5 md:justify-start md:text-left">
        <span className="md:hidden inline-flex mb-2 uppercase tracking-wider text-indigo-600 mx-auto font-semibold">Coaching</span>
        <h1 className={cx('text-2xl text-black font-black leading-tight tracking-tight text-pretty', {
          'md:text-4xl': compactTitle,
          'md:text-5xl': !compactTitle,
        })}
        >
          {pageTitle}
        </h1>
        <h3 className="mt-2 mb-4 text-base md:text-lg text-gray-500 font-medium leading-snug max-w-xl">
          {pageSubtitle}
        </h3>
        <div className="mt-2 mb-4 flex flex-col justify-center items-center sm:flex-row space-y-3 sm:space-y-0 md:justify-start">
          <Button
            size={ButtonSizes.LARGE}
            onClick={onClickCTA}
            className="w-full mr-2 pl-4 pr-5 sm:w-auto inline-flex items-center justify-center gap-1.5 shadow-lg shadow-indigo-100"
          >
            <SparklesIcon className="w-4 h-4" strokeWidth={2} />
            Find my coach
          </Button>
        </div>
        {showTestimonial && (<Stars rating="4.8 rating from over 2,400 reviews" />)}
      </div>
      <div className="hidden pt-1 md:w-1/2 md:block">
        <div className="w-full overflow-hidden rounded-xl">
          <YouTubeVideo videoID={LANDING_VIDEO} />
        </div>
      </div>
    </div>
  </div>
);

export default CoachLandingHero;
